export default `
query ContractorCompanies($siteId: Int!, $userId: Int!) {
  contractorCompanies(siteId: $siteId, userId: $userId) {
    id
    name
  }
}
`
